export const SORT_OPTIONS = [
  { name: 'popular', title: 'Popularity' },
  { name: 'low_price', title: 'Cost: Low to High' },
  { name: 'high_price', title: 'Cost: High to Low' },
  { name: 'created', title: 'Latest' },
];

export const getSortLabel = (sortKey = '') => {
  const found = SORT_OPTIONS.find(option => option.name === sortKey);
  return found ? found.title : 'Popularity';
};
